import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import LoginQuiz from "./LoginQuiz";
import Pending from "./Pending";
import Applications from "./Applications";
import { AuthProvider } from "@descope/react-sdk";
import { useSearchParams } from "react-router-dom";

const App = () => {
  // get the base URL and project ID from query parameters
  const [searchParams] = useSearchParams();
  const baseUrl = searchParams.get("baseUrl");
  const projectId = searchParams.get("projectId");
  const baseStaticUrl = searchParams.get("baseStaticUrl");

  console.log("@@@ Using params:", { baseUrl, projectId, baseStaticUrl });

  return (
    <AuthProvider
    //   projectId={projectId || "P2WW9HM7L4dT7vN6WWTi5toT8SEr"} // prodction
      projectId={projectId || "P2ZyqjJFculgoccXwwz7gtwE5YUp"} // sandbox
      baseUrl={baseUrl || "https://auth.asafshen.dev"}
      // baseStaticUrl={baseStaticUrl}
      baseStaticUrl={baseStaticUrl || "https://static.descope.org/pages"}
      // baseCdnUrl={"https://static.descope.org/pages"}
      sessionTokenViaCookie={true}
    >
      <Routes>
        <Route index element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/quiz" element={<LoginQuiz />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/applications" element={<Applications />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
